import styles from "./SuccessMessage.module.scss";
import { Icon, IconType } from "../../icons/Icon";
import { classNames } from "primereact/utils";

interface SuccessMessageProps {
  className?: string;
  label: string;
  iconType?: IconType;
}

export const SuccessMessage = ({
  className,
  label,
  iconType,
}: SuccessMessageProps) => {
  return (
    <div className={classNames(styles.root, className)}>
      {iconType && <Icon type={iconType} width="50px" height="50px" />}
      <p>{label}</p>
    </div>
  );
};
